export default "__VITE_ASSET__DPkj46TV__"